// extracted by mini-css-extract-plugin
export default {"page":"BusinessPage_page__yDv9s"};